import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  FormControl,
  Form,
  Modal,
  Alert,
  InputGroup
} from "react-bootstrap";
import {
  listarCartao,
  listarCartaoAceito,
  CadastrarCartao,
  CadastrarDinheiro,
  DeletarCartao
} from "../../providers/EstabelecimentoProvider";
import { getUser } from "../../services/Auth";
import { api_url_cartoes_image } from "../../providers/api";
import TBLCartoes from "../../components/TBLCartoes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { toast } from "react-toastify";

export default class Cards extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cartaoSelecionado: null,
      showModalCartao: false,
      showModalAlert: false,
      errorCadastro: "",
      tipoSelecionado: null,
      bandeiraSelecionada: null,
      dinheiroSelecionado: true,

      erro: {
        Tipo: "",
        Bandeira: "",
        Dinheiro: ""
      },

      cartoes: [],
      tipo: [],
      bandeira: [],
      dinheiro: [],

      cartaoBandeira: [],
      cartaoTipo: [],

      bandeiraCredito: [],
      bandeiraDebito: [],

      mensagemAlert: "",
      variantAlert: ""
    };
  }

  handleCloseModalCartao = () => {
    this.setState({ showModalCartao: false });
    this.limparForm();
  };

  handleShowModalCartao = () => {
    this.setState({ showModalCartao: true });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  alterarValorBandeira = opcao => {
    this.setState({ bandeiraSelecionada: opcao, cartaoBandeira: opcao });
  };

  alterarValorDinheiro = async opcao => {
    this.setState({ dinheiroSelecionado: opcao });
    if (this.state.dinheiroSelecionado) {
      await this.cadastrarDinheiro();
    }
  };

  alterarValorTipo = opcao => {
    if (opcao && opcao.value === "credito") {
      this.setState({
        tipoSelecionado: opcao,
        cartaoTipo: opcao,
        bandeira: this.state.bandeiraCredito
      });
    } else if (opcao && opcao.value === "debito") {
      this.setState({
        tipoSelecionado: opcao,
        cartaoTipo: opcao,
        bandeira: this.state.bandeiraDebito
      });
    }

    this.setState({ tipoSelecionado: opcao, cartaoTipo: opcao });
  };

  preencherFormEdit = dados => {
    this.setState({
      cartao: dados,
      tipoSelecionado: dados.tipo,
      bandeiraSelecionada: dados.bandeira
    });
    this.handleShowModalCartao();
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "deletar") {
      this.setState({ cartaoSelecionado: dados });
      this.handleShowModalAlert();
    } else {
      return;
    }
  };

  handleVerifyError = () => {
    const form = this.state;
    let flag = true;

    let erroMensage = {};

    Object.keys(form).forEach(campo => {
      if (campo.startsWith("cartao") && !campo.includes("cartaoSelecionado")) {
        if (!form[campo]) {
          flag = false;
          erroMensage = {
            ...erroMensage,
            [campo.replace(
              "cartao",
              ""
            )]: `Por favor, preencha o campo: ${campo.replace(
              "cartao",
              ""
            )} do cartão`
          };
        }
      }
    });

    this.setState({ erro: erroMensage });
    return flag;
  };

  cadastrarDinheiro = async () => {
    const data = {
      aceitaDinheiro: !this.state.dinheiroSelecionado.value
    };
    try {
      const response = await CadastrarDinheiro(data);
      if (response) {
        this.handleShowAlert("Método de pagamento atualizado", "success");
      }
    } catch (error) {
      this.handleShowAlert("Erro ao cadastrar método de pagamnento", "danger");
    }
  };

  cadastrarCartao = async () => {
    if (this.handleVerifyError()) {
      const data = {
        id_cartao: this.state.bandeiraSelecionada._id
      };
      try {
        const response = await CadastrarCartao(data);
        if (response) {
          const list = await listarCartaoAceito();
          this.setState({ cartoes: list });
          this.limparForm();
          this.handleShowAlert(
            "Método de pagamento cadastrado com sucesso",
            "success"
          );
        }
      } catch (error) {
        this.handleShowAlert(
          "Erro ao cadastrar método de pagamnento",
          "danger"
        );
      }
    }
  };

  deletarCartao = async () => {
    try {
      const cartao = this.state.cartaoSelecionado;
      const response = await DeletarCartao(cartao._id);
      if (response) {
        const list = await listarCartaoAceito();
        this.setState({ cartoes: list });
        this.limparForm();
        this.handleShowAlert(
          "Método de pagamento deletado com sucesso",
          "secondary"
        );
      }
    } catch (error) {
      this.handleShowAlert("Erro ao deletar método de pagamento", "danger");
    }
  };

  async componentDidMount() {
    const cartaoBandeira = await listarCartao();
    const cartoes = await listarCartaoAceito();
    const user = await getUser();

    const cartaoTipo = [
      {
        value: "credito",
        label: "Crédito"
      },
      {
        value: "debito",
        label: "Débito"
      }
    ];

    const dinheiro = [
      {
        value: true,
        label: "Sim"
      },
      {
        value: false,
        label: "Não"
      }
    ];

    cartaoBandeira.forEach(item => {
      item.value = item.tipo;
      item.label = (
        <div>
          <img
            src={`${api_url_cartoes_image}/${item.logo}`}
            alt="logo"
            height="30px"
            width="30px"
          />{" "}
          {item.bandeira}
        </div>
      );
    });

    const cartaoCredito = cartaoBandeira.filter(
      item => item.tipo === "credito"
    );
    const cartaoDebito = cartaoBandeira.filter(item => item.tipo === "debito");
    const aceitaDinheiro = user.estabelecimento.metodo_pagamento.aceitaDinheiro;
    this.setState({
      dinheiroSelecionado: {
        label: aceitaDinheiro ? "Sim" : "Não",
        value: aceitaDinheiro
      },
      cartoes: cartoes,
      tipo: cartaoTipo,
      bandeiraCredito: cartaoCredito,
      bandeiraDebito: cartaoDebito,
      dinheiro: dinheiro
    });
  }

  limparForm = () => {
    this.setState({
      cartaoSelecionado: null,
      showModalCartao: false,
      showModalAlert: false,
      errorCadastro: "",
      tipoSelecionado: null,
      bandeiraSelecionada: null,

      erro: {
        Tipo: "",
        Bandeira: ""
      },

      cartaoTipo: null,
      cartaoBandeira: null,

      mensagemAlert: "",
      variantAlert: ""
    });
  };

  render() {
    return (
      <div >
        {this.state.showAlert ? (
          <Alert
            style={{ zIndex: 99999999999 }}
            variant={this.state.variantAlert}
          >
            {this.state.mensagemAlert}
          </Alert>
        ) : null}
        <br></br>
        <Row>
          <Col md={5}>
            <h3>Métodos de pagamento</h3>
          </Col>
          <Col style={{ textAlign: "end", paddingTop: 5 }}>
            <p>
              <b>Aceita pagamento em dinheiro?</b>
            </p>
          </Col>
          <Col>
            <Select
              value={this.state.dinheiroSelecionado}
              options={this.state.dinheiro}
              onChange={e => this.alterarValorDinheiro(e)}
              isClearable={false}
              placeholder="Sim / Não"
            ></Select>
          </Col>
          <Col>
            <Button
              onClick={() => {
                this.handleShowModalCartao();
              }}
            >
              Cadastrar método
            </Button>
          </Col>
        </Row>
        <br></br>

        <div>
          <InputGroup>
            <InputGroup.Prepend>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              placeholder="Pesquisar um cartao por bandeira"
              onChange={e => this.buscarCartoes(e.target.value)}
            />
          </InputGroup>
          <TBLCartoes
            data={this.state.cartoes}
            numRows={13}
            dataCallback={this.receberDadosTabela}
            arrayCallback={docs => this.setState({ cartao: docs })}

          ></TBLCartoes>
        </div>

        <Modal
          size="xl"
          show={this.state.showModalCartao}
          onHide={this.handleCloseModalCartao}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>Cadastrar métodos de pagamento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group controlId="formCartao">
                <Row>
                  <Col>
                    <Form.Label>Tipo *</Form.Label>
                    <Select
                      value={this.state.tipoSelecionado}
                      options={this.state.tipo}
                      onChange={e => this.alterarValorTipo(e)}
                      isClearable={true}
                      placeholder="Tipo do cartão"
                    ></Select>
                    {this.state.erro.Tipo ? (
                      <div>
                        <p style={{ color: "red" }}>{this.state.erro.Tipo}</p>
                      </div>
                    ) : null}
                  </Col>
                  <Col>
                    <Form.Label>Bandeira *</Form.Label>
                    <Select
                      value={this.state.bandeiraSelecionada}
                      options={
                        this.state.tipoDelecionado !== null
                          ? this.state.bandeira
                          : []
                      }
                      onChange={e => this.alterarValorBandeira(e)}
                      isClearable={true}
                      placeholder="Bandeira do cartão"
                    ></Select>
                    {this.state.erro.Bandeira ? (
                      <div>
                        <p style={{ color: "red" }}>
                          {this.state.erro.Bandeira}
                        </p>
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalCartao();
              }}
            >
              Fechar
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.cadastrarCartao();
              }}
            >
              {"Cadastrar"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o Cartão?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarCartao();
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
